import axios from "axios";
import Cookie from "js-cookie";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { API_END_POINT } from "../config";
import { JWT_SECRET_TOKEN } from "../config";
const jwt = require("jsonwebtoken");
const token = Cookie.get("waffle_world_access_token");

export default class Orders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      activePage: 1,
      pages: 1,
      q: "",
      status: "all-orders",
      loading: false,
      responseMessage: "Loading Orders...",
      isOpen: false,
      isAllChecked: false,
      selectedItems: [],
      searchedItems: [],
      isModalOpen: false,
      selectedIndex: 0,
      filterLabel: "name",
    };
  }
  componentWillMount() {
    this.fetchOrders(this.state.status);
  }

  fetchOrders(orderName) {
    this.setState({
      orders: [],
      status: orderName,
      loading: true,
      responseMessage: "Loading Orders...",
      selectedItems: [],
    });
    if (orderName === "all-orders") {
      axios
        .get(`${API_END_POINT}/api/orders/`, {
          headers: { "auth-token": token, "x-api-key": JWT_SECRET_TOKEN },
        })
        .then((response) => {
          let SortedArray = response.data.objects;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            searchedItems: SortedArray,
            orders: response.data.objects,
            loading: false,
            responseMessage: "No Orders Found...",
          });
        })
        .catch((err) => {
          this.setState({
            loading: false,
            responseMessage: "No Orders Found...",
          });
        });

      console.log("sassung");
    } else if (orderName === "active-orders") {
      axios
        .get(`${API_END_POINT}/api/orders/status`, {
          params: { status: "active" },
          headers: { "auth-token": token },
        })
        .then((response) => {
          let SortedArray = response.data.object;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            searchedItems: SortedArray,
            orders: response.data.object,
            loading: false,
            responseMessage: "No Orders Found...",
          });
        })
        .catch((err) => {
          this.setState({
            responseMessage: "No Orders Found...",
          });
        });
    } else if (orderName === "ready-orders") {
      axios
        .get(`${API_END_POINT}/api/orders/status`, {
          params: { status: "ready" },
          headers: { "auth-token": token },
        })
        .then((response) => {
          let SortedArray = response.data.object;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            searchedItems: SortedArray,
            orders: response.data.object,
            SortedArray,
            loading: false,
            responseMessage: "No Orders Found...",
          });
        })
        .catch((err) => {
          this.setState({
            responseMessage: "No Orders Found...",
          });
        });
    } else if (orderName === "delivered-orders") {
      axios
        .get(`${API_END_POINT}/api/orders/status`, {
          params: { status: "delivered" },
          headers: { "auth-token": token },
        })
        .then((response) => {
          let SortedArray = response.data.object;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            searchedItems: SortedArray,
            orders: response.data.object,
            loading: false,
            responseMessage: "No Orders Found...",
          });
        })
        .catch((err) => {
          this.setState({
            responseMessage: "No Orders Found...",
          });
        });
    } else if (orderName === "canceled-orders") {
      axios
        .get(`${API_END_POINT}/api/orders/status`, {
          params: { status: "canceled" },
          headers: { "auth-token": token },
        })
        .then((response) => {
          let SortedArray = response.data.object;
          SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            searchedItems: SortedArray,
            orders: response.data.object,
            loading: false,
            responseMessage: "No Orders Found...",
          });
        })
        .catch((err) => {
          this.setState({
            responseMessage: "No Orders Found...",
          });
        });
    }
  }

  deleteOrder(orderId, index) {
    const requestParams = {
      orderId: orderId,
    };
    if (confirm("Bist du sicher das du die Bestellung löschen willst?")) {
      const tokenx = jwt.sign({ payload: requestParams }, JWT_SECRET_TOKEN, {
        expiresIn: "1h",
      });
      axios
        .delete(`${API_END_POINT}/api/orders/delete`, {
          data: requestParams,
          headers: { "auth-token": tokenx },
        })
        .then((response) => {
          const orders = this.state.orders.slice();
          orders.splice(index, 1);
          this.setState({ orders });
          window.alert(response.data.msg);
        });
    }
  }

  handleSelect(page) {
    axios.get(`/api/area?offset=${(page - 1) * 10}`).then((response) => {
      this.setState({
        areas: response.data.items,
        activePage: page,
      });
    });
  }

  handleSearch() {
    const { q, orders } = this.state;
    console.log(orders);
    let newState = {};
    if (!q) newState.searchedItems = orders;
    else
      newState = {
        loading: true,
        searchedItems: [],
        responseMessage: "Loading Orders...",
      };
    this.setState(newState);
    let filteredData = orders.filter((item) => {
      var label = this.state.filterLabel;
      if (label == "date") {
        // moment.locale("");
        var formatedDate = moment(item.orderTime).format("DD-MMMM-YYYY");
        return formatedDate.match(q);
      } else if (label == "name")
        return item.userName && item.userName.match(q);
      else return item.description && item.description.match(q);
    });
    this.setState({
      searchedItems: filteredData,
      loading: false,
    });
    // axios
    //   .get(`${API_END_POINT}/api/orders/search`, {
    //     params: { searchWord: this.state.q },
    //     headers: { "auth-token": token },
    //   })
    //   .then((response) => {
    //     this.setState({
    //       orders: response.data.searchedItems,
    //       loading: false,
    //       responseMessage: response.data.noMatch,
    //     });
    //     console.log(response.data.searchedItems, "response.data.searchedItems");
    //   })
    //   .catch(() => {
    //     this.setState({
    //       loading: false,
    //       responseMessage: "No Orders Found...",
    //     });
    //   });
    // }
  }
  ChangeStatus(orderId, status, index) {
    const body = {
      orderId: orderId,
      status: status,
    };
    const tokenx = jwt.sign({ payload: body }, JWT_SECRET_TOKEN, {
      expiresIn: "1h",
    });
    axios
      .post(`${API_END_POINT}/api/orders/update`, body, {
        headers: { "auth-token": tokenx },
      })
      .then((response) => {
        // window.alert(response.data.msg);
        this.state.orders[index].status = status;
        this.setState({ orders: this.state.orders });
      })
      .catch((error) => {
        window.alert("Error");
        console.log(error);
      });
  }

  ChangeStatusBack(orderId, index) {
    const body = {
      orderId: orderId,
    };
    const tokenx = jwt.sign({ payload: body }, JWT_SECRET_TOKEN, {
      expiresIn: "1h",
    });
    axios
      .post(`${API_END_POINT}/api/orders/updatestatusback`, body, {
        headers: { "auth-token": tokenx },
      })
      .then((response) => {
        // window.alert(response.data.msg);
        // this.state.orders[index].status = status;
        this.state.orders[index].status = response.data.status;
        this.setState({ orders: this.state.orders });
      })
      .catch((error) => {
        window.alert("Error");
        console.log(error);
      });
  }
  toggleMenu = () => {
    const { isOpen } = this.state;
    if (isOpen) {
      this.setState({ isOpen: false });
    } else {
      this.setState({ isOpen: true });
    }
  };
  addSelectedItems = (ischeck, id) => {
    const { selectedItems } = this.state;
    if (ischeck) {
      this.setState({
        selectedItems: [...selectedItems, id],
      });
    } else {
      let array = [...selectedItems];
      let index = array.indexOf(id);
      array.splice(index, 1);
      this.setState({
        selectedItems: [...array],
      });
    }
  };
  ChangeMultiStatus = (value) => {
    const { selectedItems, orders } = this.state;
    const body = {
      orderIds: selectedItems,
      status: value,
    };
    axios
      .post(`${API_END_POINT}/api/orders/updatestatus`, body, {
        headers: { "auth-token": token },
      })
      .then((response) => {
        if (selectedItems.length === 1) {
          window.alert("Order Status Updated");
        } else {
          window.alert(response.data.message);
        }
        if (this.state.status !== "all-orders") {
          let newArray = orders.filter(
            (item) => !selectedItems.includes(item._id)
          );
          this.setState({
            orders: newArray,
            selectedItems: [],
            isAllChecked: false,
          });
        } else {
          orders.map((item) => {
            if (selectedItems.includes(item._id)) {
              item.status = value;
            }
          });
          this.setState({ selectedItems: [], isAllChecked: false });
        }

        // this.state.orders[index].status = status;
        // this.setState({ orders: this.state.orders });
      })
      .catch((error) => {
        window.alert("Error");
        console.log(error);
      });
    console.log("bastard");
    () => this.fetchOrders("active-orders");
    () => this.fetchOrders("all-orders");
  };
  multiSelect = (value) => {
    const { orders, isAllChecked } = this.state;
    if (value) {
      let selectedId = [];
      orders.map((item) => selectedId.push(item._id));
      this.setState({ selectedItems: selectedId, isAllChecked: true });
    } else {
      this.setState({ selectedItems: [], isAllChecked: false });
    }
  };
  toggleModal = (id) => {
    const { isModalOpen } = this.state;
    if (!isModalOpen) {
      this.setState({ isModalOpen: true, selectedIndex: id });
    } else {
      this.setState({ isModalOpen: false });
    }
  };
  render() {
    const {
      status,
      selectedItems,
      isAllChecked,
      isModalOpen,
      selectedIndex,
      orders,
      searchedItems,
    } = this.state;
    return (
      <React.Fragment>
        <div className="row animated fadeIn">
          <div className="col-12">
            <div className="row space-1">
              <div className="col-sm-4">
                <h3>Bestellungen</h3>
              </div>
              <div className="col-sm-4">
                <div className="input-group">
                  <select
                    value={this.state.filterLabel}
                    onChange={(e) =>
                      this.setState({ filterLabel: e.target.value })
                    }
                    class="custom-select"
                    id="inputGroupSelect01"
                  >
                    <option selected>Auswahl...</option>
                    <option value="name">Name</option>
                    <option value="desc">Beschreibung</option>
                    <option value="date">Datum</option>
                  </select>
                  <input
                    className="form-control"
                    type="text"
                    name="search"
                    placeholder="..."
                    value={this.state.q}
                    // onChange={(event) => this.setState({q: event.target.value})}
                    onChange={(event) =>
                      this.setState({ q: event.target.value }, () => {
                        if (this.state.q === "") {
                          this.fetchOrders(this.state.status);
                        }
                      })
                    }
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        this.handleSearch();
                      }
                    }}
                  />
                  <span className="input-group-btn">
                    <button
                      type="button"
                      onClick={() => this.handleSearch()}
                      className="btn btn-info search-btn"
                    >
                      Suchen
                    </button>
                  </span>
                </div>
              </div>

              <div className="col-sm-4 pull-right mobile-space">
                <Link to="/orders/order_form">
                  <button type="button" className="btn btn-success">
                    Neue Bestellung erstellen
                  </button>
                </Link>
              </div>
            </div>

            <div>
              <div className="row d-flex justify-content-between">
                <div className="float-left col-12 col-md-9 space-1">
                  <button
                    type="button"
                    style={{
                      marginRight: 5,
                      borderRadius: 0,
                    }}
                    className={`${
                      status === "all-orders" ? "btn-primary" : ""
                    } btn btn-default`}
                    onClick={() => this.fetchOrders("all-orders")}
                  >
                    Alle Bestellungen
                  </button>

                  <button
                    type="button"
                    style={{
                      marginLeft: 5,
                      marginRight: 5,
                      borderRadius: 0,
                    }}
                    className={`${
                      status === "active-orders" ? "btn-primary" : ""
                    } btn btn-default`}
                    onClick={() => this.fetchOrders("active-orders")}
                  >
                    Aktive Bestellungen
                  </button>

                  <button
                    type="button"
                    style={{
                      marginLeft: 5,
                      marginRight: 5,
                      borderRadius: 0,
                    }}
                    className={`${
                      status === "ready-orders" ? "btn-primary" : ""
                    } btn btn-default`}
                    onClick={() => this.fetchOrders("ready-orders")}
                  >
                    Abholbereite Bestellungen
                  </button>

                  <button
                    type="button"
                    style={{
                      marginLeft: 5,
                      borderRadius: 0,
                    }}
                    className={`${
                      status === "delivered-orders" ? "btn-primary" : ""
                    } btn btn-default`}
                    onClick={() => this.fetchOrders("delivered-orders")}
                  >
                    Abgeholte Bestellungen
                  </button>

                  <button
                    type="button"
                    style={{
                      marginLeft: 5,
                      borderRadius: 0,
                    }}
                    className={`${
                      status === "canceled-orders" ? "btn-primary" : ""
                    } btn btn-default`}
                    onClick={() => this.fetchOrders("canceled-orders")}
                  >
                    Stornierte Bestellungen
                  </button>
                </div>
                {selectedItems && selectedItems.length !== 0 ? (
                  <div className="float-right col-12 col-md-3 space-1">
                    <Dropdown
                      isOpen={this.state.isOpen}
                      toggle={this.toggleMenu}
                    >
                      <DropdownToggle variant="success" id="dropdown-basic">
                        Massenstatus ändern
                      </DropdownToggle>

                      <DropdownMenu
                        style={{ transform: "translate3d(0px, 25px, 0px)" }}
                        data-placement="bottom-start"
                        style={{ marginLeft: -25 }}
                      >
                        <DropdownItem
                          onClick={() => this.ChangeMultiStatus("ready")}
                        >
                          Bestellung abholbereit setzen
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => this.ChangeMultiStatus("delivered")}
                        >
                          Bestellung abgeholt
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                ) : null}
              </div>

              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>
                        #
                        <div class="form-check mx-2 mt-0">
                          <input
                            class="form-check-input"
                            style={{
                              marginTop: "-16.7px",
                              marginLeft: "-13px",
                            }}
                            type="checkbox"
                            checked={isAllChecked}
                            onChange={(e) => this.multiSelect(e.target.checked)}
                          />
                        </div>
                      </th>
                      <th>Anzahl Artikel</th>
                      <th>Bestellstatus</th>
                      <th>Kunde</th>
                      <th>Beschreibung</th>
                      <th>Bestelldatum</th>
                      <th>Abholdatum</th>
                      <th>Abholort</th>
                      <th>Bestellstatus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(searchedItems) &&
                    searchedItems.length >= 1 ? (
                      searchedItems.map((order, index) => (
                        <tr key={index}>
                          <td>
                            <div className="d-flex align-items-center">
                              <p className="m-0">{index + 1}</p>
                              <div class="form-check mx-2 mt-0">
                                <input
                                  class="form-check-input"
                                  style={{ marginTop: "-5.700000000000003px" }}
                                  type="checkbox"
                                  checked={
                                    selectedItems.includes(order._id)
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    this.addSelectedItems(
                                      e.target.checked,
                                      order._id
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </td>
                          <td>{order.items.length}</td>
                          <td className="order-status">{order.status}</td>
                          <td>{order.userName}</td>
                          <td>{order.description}</td>
                          <td>{moment(order.date).format("DD.MM.YYYY")}</td>

                          <td>
                            {moment(order.orderDeliverydate).format(
                              "DD.MM.YYYY"
                            )}
                          </td>
                          <td>{order.selectedDeliveryLocation}</td>
                          {/* <td>
                      <Link to={`${API_END_POINT}/area_resource/${order.ID}`}>
                        <button type="button" className="btn btn-info btn-sm">Resource</button>
                      </Link>
                    </td> */}
                          <td>
                            <div className="d-flex justify-content-between align-items-baseline">
                              <div>
                                <button
                                  className="btn"
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                  }}
                                  onClick={() =>
                                    this.ChangeStatusBack(order._id, index)
                                  }
                                >
                                  <span
                                    className="fa fa-caret-left fa-xs"
                                    aria-hidden="true"
                                  ></span>
                                </button>

                                {order.status === "active" ? (
                                  <button
                                    className="btn btn-danger btn-sm mx-2"
                                    onClick={() =>
                                      this.ChangeStatus(
                                        order._id,
                                        "ready",
                                        index
                                      )
                                    }
                                  >
                                    Bestellung abholbereit setzen
                                  </button>
                                ) : order.status === "ready" ? (
                                  <button
                                    className="btn btn-primary btn-sm mx-2"
                                    onClick={() =>
                                      this.ChangeStatus(
                                        order._id,
                                        "delivered",
                                        index
                                      )
                                    }
                                  >
                                    Bestellung abgeholt setzen
                                  </button>
                                ) : order.status === "canceled" ? (
                                  <button className="btn btn-danger btn-sm mx-2">
                                    Storniert
                                  </button>
                                ) : (
                                  <button
                                    disabled
                                    className="btn btn-success btn-sm mx-2"
                                  >
                                    Abgeholt
                                  </button>
                                )}
                              </div>

                              {/* <Link to={`/orders/order/${order._id}`}> */}
                              <button
                                type="button"
                                className="btn btn-info btn-sm mx-2"
                                onClick={() => this.toggleModal(index)}
                              >
                                Bestellung ansehen
                              </button>
                              {/* </Link> */}

                              <Link to={`/orders/edit_order/${order._id}`}>
                                <span
                                  className="fa fa-edit px-2"
                                  aria-hidden="true"
                                ></span>
                              </Link>

                              <span
                                className="fa fa-trash px-2"
                                aria-hidden="true"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  this.deleteOrder(order._id, index)
                                }
                              ></span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="15" className="text-center">
                          {this.state.responseMessage}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* <div className="text-center">
            <Pagination prev next items={this.state.pages} activePage={this.state.activePage} onSelect={this.handleSelect.bind(this)}> </Pagination>
          </div> */}
            </div>
          </div>
        </div>
        {/* ORDER'S ITEM MODAL */}
        <div>
          <Modal
            size="lg"
            className="modal-dialog-centered"
            isOpen={isModalOpen}
            toggle={this.toggleModal}
          >
            <ModalHeader toggle={this.toggleModal}>
              <div className="d-flex justify-content-between w-100">
                <div>Bestellung Artikel: Lieferdatum: </div>
                <div className="px-3">
                  Gesamt Preis :
                  {Array.isArray(searchedItems) &&
                    searchedItems.length > 0 &&
                    searchedItems[selectedIndex].totalPrice}
                  €
                </div>
              </div>
            </ModalHeader>
            <ModalBody>
              {/* <p>{orders.length > 0 ? orders[selectedIndex]._id : null}</p> */}
              <div className="table-responsive border-0">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Artikel Nr.#</th>
                      <th>Bild</th>
                      <th>Marke</th>
                      <th>Name</th>
                      <th>Bestellbeschreibung</th>
                      <th>Preis</th>
                      <th>Gramm Anzahl</th>
                      <th>Marinade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {searchedItems.length > 0 ? (
                      searchedItems[selectedIndex].items.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {
                              <img
                                style={{ height: "50px", width: "50px" }}
                                src={item.image && item.image}
                              />
                            }
                          </td>
                          <td>{item.brandName}</td>
                          <td>{item.name}</td>
                          <td>
                            {searchedItems[selectedIndex].orderdescription}
                          </td>
                          <td>{item.price} €</td>
                          <td>
                            {item.numberOfOrders ? item.numberOfOrders : "-"} g
                          </td>
                          <td>{item.selectedMarinade}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="15" className="text-center">
                          {this.state.responseMessage}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Orders.jsx